import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class CardActionsPanel extends React.Component {
  render() {
    const { children, position, clickable } = this.props;

    const panelPosition = (position === 'left' ? 'Card__Actions__Panel__left' : '')
                            ||
                          (position === 'right' ? 'Card__Actions__Panel__right' : '');
    const panelClickable = (clickable ? 'Card__Actions__Panel__clickable' : '');

    return (
      <div
        className={classnames('Card__Actions__Panel', panelPosition, panelClickable)}
      >
        {children}
      </div>
    );
  }
}

CardActionsPanel.propTypes = {
  children: PropTypes.any.isRequired,
  position: PropTypes.any.isRequired,
  clickable: PropTypes.bool,
};

CardActionsPanel.defaultProps = {
  clickable: null,
};

export default CardActionsPanel;
